import { Route } from '@angular/router';
import { Permissions } from '../../../access/shared/authorization/permissions';
import { CommandeParamListRouting } from './commande-param-list/commande-param-list-routing';
import { CommandeParamSettingsRouting } from './commande-param-settings/commande-param-settings-routing';
import { CommandeParamComponent } from './commande-param.component';

export const CommandeParamRouting: Route = {
  path: 'linge-hebergement-param',
  component: CommandeParamComponent,
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    CommandeParamListRouting,
    CommandeParamSettingsRouting
  ],
  data: {
    breadcrumb: "Paramètres linge d'hébergement",
    'role': [
      Permissions.ROLE_HEBERGEMENT,
    ],
  }
};
